import { useEffect, useRef, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { resolveAvatarUrl } from "@/lib/avatar";
import { CallCenter, type CallCenterHandle } from "./CallCenter";
import { callBus } from "./call-bus";

type Me = { id: string; name: string; avatar: string | null } | null;

export function GlobalCallCenter() {
  const [me, setMe] = useState<Me>(null);
  const ref = useRef<CallCenterHandle | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user || cancelled) return;
      const { data: profile } = await supabase
        .from("profiles")
        .select("id, full_name, email, avatar_url")
        .eq("id", user.id)
        .maybeSingle();
      if (cancelled) return;
      const avatar = profile?.avatar_url ? await resolveAvatarUrl(profile.avatar_url) : null;
      setMe({
        id: user.id,
        name: profile?.full_name || profile?.email || user.email || "Saya",
        avatar: avatar ?? null,
      });
    })();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    callBus.register(ref.current);
    return () => callBus.register(null);
  }, [me]);

  return <CallCenter ref={(h) => { ref.current = h; callBus.register(h); }} me={me} />;
}
